import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  Alert,
  AlertBody,
  AlertIcon,
} from '@lifeomic/chroma-react/components/Alert';
import { AlertTriangle } from '@lifeomic/chromicons';

const messages = defineMessages({
  warning: {
    id: 'phc-web-toolkit.subjectViewer.actionPlan.duplicateActiveWarning',
    defaultMessage:
      'This member has more than one Active action plan. The first plan is shown below. Generate with AI is unavailable until extras are resolved.',
  },
});

export const DuplicateActiveActionPlanBanner: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Alert statusType="warning" fullWidth>
      <AlertIcon icon={AlertTriangle} />
      <AlertBody>{formatMessage(messages.warning)}</AlertBody>
    </Alert>
  );
};

DuplicateActiveActionPlanBanner.displayName = 'DuplicateActiveActionPlanBanner';
